import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
//import { useAuth } from "utils/hooks/useAuth";
import { getEnvCode } from "utils/hooks/useSalesNetworks";
import { setLocalStorageAccessToken, setLocalStorageItem } from "utils/helpers/localStorage";
import { useAppDispatch } from "store/hooks";
import { setIsAuth, setProfile } from "store/authSlice";
import { getProfileRequest } from "api/auth";

const LoggedInCallbackRoute: React.FC = () => {
  const location = useLocation();
  const searchPararms = new URLSearchParams(location.search);
  const token = searchPararms.get("token");

  //const [loading, setLoading] = useState(true);
  //const [authFailed, setAuthFailed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const def_env = getEnvCode();
  
  const defaultRoute = sessionStorage.getItem('redirectTo') || "/" + def_env + '/'
  

  /**
   * Get jwt token by query params
   * then ask backend for user informations
   */
  useEffect(() => {
    if(token === null) {
        //setLoading(false);
        //setAuthFailed(true);
    } else {
        //userService.setToken(parsed.token);
        setLocalStorageAccessToken(token);

        getProfileRequest().then((res) => {
            //setProfile(res.data);
            //setLoading(false);
            //setAuthFailed(!res);

            dispatch(setProfile(res.data as any));
            dispatch(setIsAuth(true));
            setLocalStorageItem("_user", JSON.stringify(res.data));

             navigate(defaultRoute, { replace: true });
        });

        
       
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  

  return (
    <div>Loading...</div>
  );
}

export default LoggedInCallbackRoute;